export function ready(fn) {
  if (document.readyState != 'loading'){
    fn();
  } else if (document.addEventListener) {
    //@ts-ignore
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    //@ts-ignore
    document.attachEvent('onreadystatechange', function() {
      if (document.readyState != 'loading')
        fn();
    });
  }
}

export function getCookie(c) {
  return (c=(document.cookie.match('(^|; )'+ c +'=([^;]*)')||0)[2]) && decodeURIComponent(c);
}
